import type { ReactNode } from "react";

/**
 * Title row for signed-in app pages (Saved, Account): a compact heading with
 * an optional trailing element (a count badge) and a one-line subtitle.
 * App pages lead with their content, not a marketing-size hero.
 */
export const PageTitle = ({
  title,
  subtitle,
  trailing,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  trailing?: ReactNode;
}) => (
  <div className="mb-6">
    <div className="flex items-center gap-3">
      <h1 className="text-2xl font-bold tracking-tight text-gray-50 sm:text-3xl">
        {title}
      </h1>
      {trailing}
    </div>
    {subtitle && <p className="mt-1.5 text-gray-400">{subtitle}</p>}
  </div>
);
